import { Address as AddressType } from "../enums/checkoutShipping";

export default class Address {
    id?:string;
    key?:string;
    city: string;
    company: string;
    country: string;
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    extension?: string;
    postalCode: string;
    state: string;
    streetName: string;
    additionalStreetInfo: string;
    title: string;
    vatId?: string;
    taxRegisterationNum?: string;
    isDefaultAddress?: boolean;
    isPOBoxAddress?:boolean;
    type?: string = AddressType.SHIPPING;
    custom?:any
    constructor(address: any = {}) {
        this.id = address.id;
        this.key = address?.key;
        this.title = address.title;
        this.email = address.email;
        this.firstName = address.firstName;
        this.lastName = address.lastName;
        this.company = address.company;
        this.streetName = address.streetName;
        this.additionalStreetInfo = address.additionalStreetInfo;
        this.postalCode = address.postalCode;
        this.state = address.state;
        this.city = address.city;
        this.country = address.country;
        this.phone = address.phone;
        this.extension = address?.custom?.fields?.phoneExtension;
        this.vatId = address?.vatId;
        this.taxRegisterationNum = address?.taxRegisterationNum;
        this.isDefaultAddress = false;
        this.isPOBoxAddress = false;
        this.custom = address.custom;
    }
}
